import { lazy } from 'react';

export const ThemeForm = lazy(() => import('./ThemeForm'));
